<div class="loader-overlay" *ngIf="isLoading">
  <div class="loader-content">
    <img src="images/ABL-Ceramica-logo-4fe96b93.svg" alt="Logo" class="loader-logo" />
    <div class="spinner"></div>
  </div>
</div>
